import { Link } from 'react-router';

import { usePlayerLinkRule } from '@hooks/useLinkRule';

export const LinkOrAnchor = ({ children, enableUclPlayerPage, playerId, onClickEvent }) => {
  const playerLink = usePlayerLinkRule(playerId);
  if (enableUclPlayerPage) {
    return <a href={playerLink}>{children}</a>;
  } else {
    return (
      <Link to={`/player/${playerId}`} onClick={onClickEvent}>
        {children}
      </Link>
    );
  }
};

export default LinkOrAnchor;
